import { Box, Typography } from '@material-ui/core';
import LinearProgress from '@material-ui/core/LinearProgress';
import { Theme, createStyles, withStyles } from '@material-ui/core/styles';

const _ProgressBar = withStyles((theme: Theme) =>
  createStyles({
    root: {
      height: 20,
      borderRadius: 5,
    },
    colorPrimary: {
      backgroundColor: theme.palette.grey[theme.palette.type === 'light' ? 200 : 700],
    },
    bar: {
      borderRadius: 5,
    },
  }),
)(LinearProgress);

export const ProgressBar = (props) => {
  return (
    <Box display="flex" alignItems="center" mt={1}>
      <Box width="100%" mr={2}>
        <_ProgressBar variant="determinate" {...props} />
      </Box>
      <Box minWidth={35}>
        <Typography variant="body1" color="textSecondary" style={{ fontSize: '1.5rem' }}>
          {`${Math.round(props.value)}%`}
        </Typography>
      </Box>
    </Box>
  )
}